import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83f08d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-processing" }


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingProcess',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: 'In Process...',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_DoubleBounceLoader = _resolveComponent("DoubleBounceLoader")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DoubleBounceLoader, { size: 20 }),
    _createElementVNode("span", null, _toDisplayString(__props.message), 1)
  ], 512)), [
    [_vShow, __props.loading]
  ])
}
}

})